import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token + cache-buster su GET per impedire stale su PWA iOS
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Cache-buster su tutte le GET: param _ts che non viene cachato
    const method = (config.method || 'get').toLowerCase();
    if (method === 'get') {
      config.params = { ...(config.params || {}), _ts: Date.now() };
      config.headers['Cache-Control'] = 'no-cache';
      config.headers['Pragma'] = 'no-cache';
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle 401 — clear session, reload ONCE
let isLoggingOut = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !isLoggingOut) {
      const url = error.config?.url || '';
      // Non intercettare 401 su login o validazione
      if (url.includes('/auth/login') || url.includes('/auth/me')) {
        return Promise.reject(error);
      }
      isLoggingOut = true;
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default api;
